const englishTranslations = {
  login: {
    REGISTRATION: {
      inputLbl1: "Patient registration ID",
      inputLbl2: "Password",
      "forgot-id": " Forgot Patient ID?",
      "forgot-pwd": "Forgot password?",
      button1: "Login",
      message: "Don't have patient ID?",
      button2: "Patient Registration",
      confirm: "Confirm patient ID.",
    },
    DOBSTEP: {
      thanku: "Thank You",
      dob: "What is your Age?",
      button: "Continue",
      isMinorPrompt:
        "My age is below 18. I confirm that I’m accessing the platform under the supervision of my parent or guardian, who in this case will be deemed as the recipient / end-user of the Services.",
      isMinorPromptCTA: "I agree",
      personalDetailsMessage:"We will now take some of your personal details for registration",
    },
    BOTTOMNAV: {
      today: "Today",
      health: "My Health",
      clinic: "My Clinic",
    },
    EMAIL: {
      message1: "I don't have an email ID.",
      message2: "Please send clinic messages on my mobile phone.",
    },
    SUCCESS: {
      message1: "Congratulations!!",
      message2: "You app registered ID is",
      message3: "Please write this number on your",
      message4: "patient file. You will need this number",
      message5: "to log in to the App",
      button: "Create Password",
    },
    CONDITION: {
      description1: "I accept the",
      description2: " Terms & Conditions",
      description3: " and",
      description4: " Privacy Policy",
      description5: " of IC4.health",
      button: "Submit",
    },
    404: "Not Found",
  },
};
const marathiTranslations = {
  login: {
    REGISTRATION: {
      inputLbl1: "रुग्ण नोंदणी आयडी",
      inputLbl2: "पासवर्ड",
      "forgot-id": "तुम्ही पेशंट आयडी विसरलात का? ",
      "forgot-pwd": "पासवर्ड विसरलात का?",
      button1: "लॉगिन करा",
      message: "पेशंट आयडी नाही?",
      button2: "पेशंट नोंदणी",
      confirm: "पेशंट आयडीची पुष्टी करा",
    },
    DOBSTEP: {
      thanku: "धन्यवाद",
      dob: "तुमचे वय किती आहे?",
      button: "पुढे जा",
      isMinorPrompt:
        "माझे वय 18 वर्षांपेक्षा कमी आहे. मी पुष्टी करतो की मी माझ्या पालकांच्या किंवा पालकांच्या देखरेखीखाली प्लॅटफॉर्मवर प्रवेश करत आहे, ज्यांना या प्रकरणात सेवांचा प्राप्तकर्ता/अंतिम वापरकर्ता म्हणून गणले जाईल.",
      isMinorPromptCTA: "मी सहमत आहे.",
      personalDetailsMessage:"आम्ही आता नोंदणीसाठी तुमची काही वैयक्तिक माहिती घेऊ",
    },
    BOTTOMNAV: {
      today: "आज",
      health: "माझे आरोग्य",
      clinic: "माझे क्लिनिक",
    },
    EMAIL: {
      message1: "माझ्याकडे ईमेल आयडी नाही आहे.",
      message2: "कृपया माझ्या मोबाईलवर क्लिनिकचे संदेश पाठवा.",
    },
    SUCCESS: {
      message1: "अभिनंदन",
      message2: "तुमचा अँपवर नोंदणी आयडी आहे",
      message3: "कृपया तुमच्या पेशंटच्या फाईलवर हा",
      message4: "नंबर लिहा. अँपमध्ये लॉग इन करण्यासाठी",
      message5: "तुम्हाला ह्या नंबरची आवश्यकता असेल",
      button: "पासवर्ड तयार करा",
    },
    CONDITION: {
      description1: "मी IC4.health चे",
      description2: " अटी आणि शर्ती ",
      description3: " आणि",
      description4: " प्रायव्हसी-पॉलिसि",
      description5: " स्वीकारतो",
      button: "पुढे जा",
    },
    404: "नाही मिळाले",
  },
};
const hindiTranslations = {
  login: {
    REGISTRATION: {
      inputLbl1: "पेशंट आईडी",
      inputLbl2: "पासवर्ड",
      "forgot-id": "क्या आप पेशंट आईडी भूल गए?",
      "forgot-pwd": "क्या आप पासवर्ड भूल गए?",
      button1: "लॉग इन करें",
      message: "पेशंट आईडी नहीं हैं?",
      button2: "पेशंट रजिस्ट्रेशन",
      confirm: "पेशंट आईडी की जाँच करें",
    },
    DOBSTEP: {
      thanku: "धन्यवाद",
      dob: "आपकी उम्र क्या है?",
      button: "आगे बढें",
      isMinorPrompt:
        "मेरी आयु 18 वर्ष से कम है। मैं पुष्टि करता हूं कि मैं अपने माता-पिता या अभिभावक की देखरेख में प्लेटफॉर्म का उपयोग कर रहा हूं, जिन्हें इस मामले में सेवाओं का प्राप्तकर्ता / अंतिम-उपयोगकर्ता माना जाएगा।",
      isMinorPromptCTA: "मैं सहमत हूं।",
      personalDetailsMessage:"अब हम रजिस्ट्रीकरण के लिए आपकी कुछ व्यक्तिगत जानकारी लेंगे",
    },
    BOTTOMNAV: {
      today: "आज",
      health: "मेरा स्वास्थ्य",
      clinic: "मेरा क्लिनिक",
    },
    EMAIL: {
      message1: "मेरे पास ईमेल आईडी नहीं हैं।",
      message2: "कृपया मेरे मोबाइल फोन पर क्लिनिक के संदेश भेजें।",
    },
    SUCCESS: {
      message1: "बधाई हो",
      message2: "आपका ऐप रजिस्ट्रेशन आईडी हैं",
      message3: "कृपया इस नंबर को अपनी पेशंट फ़ाइल",
      message4: "पर लिखें। ऐप में लॉग इन करने के लिए आपको",
      message5: "इस नंबर की आवश्यकता होगी|",
      button: "पासवर्ड बनाएं",
    },
    CONDITION: {
      description1: "मैं IC4.health के",
      description2: " नियम,शर्तें",
      description3: " और",
      description4: " गोपनीयता की निती",
      description5: " स्वीकारता हूं|",
      button: "आगे बढें",
    },
    404: "नहीं मिल पाया",
  },
};
export const translations = {
  EN: englishTranslations,
  MR: marathiTranslations,
  HI: hindiTranslations,
};
